import { AlphanumericTypeCell } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Columns/Cells/CustomTransactionItem/AlphanumericTypeCell';
import { DateTypeCell } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Columns/Cells/CustomTransactionItem/DateTypeCell';
import { PulldownTypeCell } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Columns/Cells/CustomTransactionItem/PulldownTypeCell';
import { TextTypeCell } from '@/features/InvoiceReport/Edit/components/InvoiceTransaction/Columns/Cells/CustomTransactionItem/TextTypeCell';
import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { ComponentType } from 'react';
import { Control, Path, RegisterOptions } from 'react-hook-form';

type CustomTransactionItemsProps = {
  index: number;
  property: TransactionProperty;
  control: Control<PaymentRequestForm, unknown>;
  inputId: string;
  name: Path<PaymentRequestForm>;
  rules: RegisterOptions<PaymentRequestForm, Path<PaymentRequestForm>>;
};

export const CustomTransactionItems: Record<
  string,
  ComponentType<CustomTransactionItemsProps>
> = {
  pulldown: PulldownTypeCell,
  text: TextTypeCell,
  alphanumeric: AlphanumericTypeCell,
  date: DateTypeCell,
};
